import { COLLECT_COMPAT } from '@/api/apiModules'

import dictionary from '@/utils/dictionary'
export default {
  viewType: 'table',
  module: COLLECT_COMPAT,
  listUrl: `${COLLECT_COMPAT}/listForUpload`,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    },
    {
      fieldName: 'name',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  // relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchWidth: 500,
    searchPlaceholder: 'pocMng.searchReportPlaceholder',
    searchFieldNameArr: ['projectCustomer', 'name', 'createUser', 'versionOrType'],
    items: [
      {
        slot: 'refresh-rigtht',
        label: '手工上报【软件】兼容性案例',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'personalSoftCompatibleUpload'
      },
      {
        slot: 'refresh-rigtht',
        label: '手工上报【外设】兼容性案例',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'personalPeriCompatibleUpload'
      }
    ],
    tips: {
      label:
        '注：本列表包括个人项目中与非项目的外设与软件的兼容性测试通过的数据，执行上报后可以提供给全国售前或售后人员做为兼容性参考',
      type: 'info'
    }
  },

  view: {
    columns: [
      {
        props: {
          label: 'pocMng.projectNumber',
          prop: 'projectCode',
          width: 120,
          sortField: 'projectNumber'
        }
      },
      {
        props: {
          label: '项目客户',
          prop: 'projectCustomer',
          width: 200,
          sortField: 'projectCustomer'
        }
      },
      {
        props: {
          label: '名称',
          prop: 'name',
          width: 200,
          sortField: 'name'
        }
      },
      {
        props: {
          label: '软件版本/外设类型',
          prop: 'versionOrType',
          sortField: 'versionOrType',
          width: 180
        },
        filter: true
      },
      {
        props: {
          label: '类型',
          prop: 'collectType',
          sortField: 'collectType',
          width: 80
        },
        filter: true,
        dataType: 'enum'
      },
      {
        props: {
          label: '来源',
          prop: 'collectSourceFrom',
          sortField: 'collectSourceFrom',
          width: 100
        },
        filter: true,
        dataType: 'enum'
      },
      {
        props: {
          label: '是否兼容（自测）',
          prop: 'hasCompatible',
          sortField: 'hasCompatible',
          width: 100
        },
        filter: true,
        dataType: 'enum'
      },
      {
        props: {
          label: '兼容性结论（自测）',
          prop: 'compatibleDesc',
          width: 360
        },
        dataType: 'custom',
        custom: function(data, h) {
          if (!data || !data.compatibleDesc) {
            return
          }
          let result = ''
          let compatibleDescObj = {}
          for (const item of JSON.parse(data.compatibleDesc)) {
            let statusCn = dictionary['compatibleStatus'][item.compatibleStatus].label
            const name = `${item.productVersion}-${item.os}(${statusCn})`
            if (!compatibleDescObj[name]) {
              compatibleDescObj[name] = []
            }
            compatibleDescObj[name].push(item.limitDesc)
          }
          Object.keys(compatibleDescObj).forEach(key => {
            let desc = ''
            for (const index in compatibleDescObj[key]) {
              const number = Number.parseInt(index) + 1
              desc = desc + number + '、' + compatibleDescObj[key][index] + '\r\n'
            }
            result = result + key + '：\r\n' + desc
          })
          return result
        }
      },
      {
        props: {
          label: '案例已上报',
          prop: 'hasPush',
          sortField: 'hasPush',
          width: 120
        },
        filter: true,
        dataType: 'enum'
      },
      {
        props: {
          label: '创建人',
          prop: 'createUser',
          sortField: 'createUser',
          width: 100
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 180
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '1'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '兼容性案例上报',
        command: 'compatibleReUpload',
        name: 'compatibleReUpload'
      }
    ]
  }
}
